module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAOCAYAAADuQ3ZcAAAAAXNSR0IArs4c6QAAABBJREFUGFdjqDvy5j8DpQQACRUsd9xuUWgAAAAASUVORK5CYII="